module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/ko/3-a9cb557420e709508779c03cdd12be73.jpg";